import React, { useCallback } from 'react';
import { SortingInput } from 'components/input';

interface Props {
  event: any;
  title: string;
  showSearchInput?: boolean;
  titleStyle?: React.CSSProperties;
  onSortClick?: (...args) => any;
}

const TableInputSortFilter = (props: Props) => {
  const { event, title, showSearchInput = true, titleStyle, onSortClick } = props;
  const { onClick } = event.column.getSortByToggleProps();
  const { filterValue = '', setFilter } = event.column;
  const handleInputChange = useCallback(
    (value: string) => {
      setFilter(value);
    },
    [event],
  );

  return (
    <SortingInput
      title={title}
      inputValue={filterValue}
      onSortClick={onSortClick ? onSortClick : onClick}
      onInputChange={handleInputChange}
      showSearchInput={showSearchInput}
      titleStyle={titleStyle}
    />
  );
};

export default TableInputSortFilter;
